import type { FaireProductEntity } from "../../entity_types/product";

export const p_d9uqn7fy7d: FaireProductEntity = {
  token: "p_d9uqn7fy7d",
  type: "product",
  name: "Vanilla Pumpkin Marshmallow Maximum Scented Wax Melt",
  brandName: "The Candle Daddy",
  imageUrl:
    "https://cdn.faire.com/fastly/e0829d0f570c07685a8bb7377af7a29c163fef6b55f32d517c7609afd0f8577d.png",
  priceDollars: 2.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/985c2d9064dcf385f76bc5b24af8940e45fb450c693c296ee0db5db7c4f2b31d.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
